module.exports = __webpack_public_path__ + "img/nikud-search.1472e6e7.png";